import { timelineMilestones } from '@/mocks/aboutData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

const bgImages: Record<string, string> = {
  '2013': readdy('bstory-v3-2013'),
  '2015': readdy('bstory-v3-2015'),
  '2017': readdy('bstory-v3-2017'),
  '2019': readdy('bstory-v3-2019'),
  '2021': readdy('bstory-v3-2021'),
  '2023': readdy('bstory-v3-2023'),
  '2025': readdy('bstory-v3-2025'),
  '2026': readdy('bstory-v3-2026'),
};

export default function BrandStory() {
  return (
    <section className="relative bg-white py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">

          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">品牌故事</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                从一家门店，到多省连锁
              </h2>
              <p className="text-gray-400 text-sm mt-3 max-w-xl mx-auto">
                十余年坚持，每一步都走得踏实而坚定
              </p>
            </div>
          </ScrollReveal>

          <div className="relative">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-brand-cream -translate-x-1/2" />

            <div className="space-y-6 md:space-y-0">
              {timelineMilestones.map((item, index) => {
                const isLeft = index % 2 === 0;
                return (
                  <ScrollReveal key={item.year} variant={isLeft ? 'fade-right' : 'fade-left'} delay={index * 100}>
                    <div className="flex flex-col md:flex-row items-center gap-4 md:gap-0">
                      <div className={`flex-1 ${isLeft ? 'md:pr-16 md:text-right' : 'md:pl-16 md:order-1'} w-full`}>
                        <div className="relative bg-brand-gray rounded-2xl p-5 md:p-6 border border-brand-light/30 hover:border-brand-cream hover:shadow-md transition-all duration-300 overflow-hidden group/card">
                          <div className="absolute inset-0 opacity-[0.08] group-hover/card:opacity-[0.13] transition-opacity duration-500">
                            <img
                              src={bgImages[item.year] || readdy(`bstory-v3-${item.year}`)}
                              alt=""
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="relative z-10">
                            <span className="inline-block text-xs font-bold text-brand-gold bg-brand-light px-3 py-1 rounded-full mb-2">
                              {item.year}
                            </span>
                            <h3 className="text-base md:text-lg font-semibold text-brand-deep mb-1">{item.title}</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                          </div>
                        </div>
                      </div>

                      <div className="relative z-10 flex-shrink-0 hidden md:flex">
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-deep text-white">
                          <i className={`${item.icon} text-lg`} />
                        </div>
                      </div>

                      <div className={`flex-1 ${isLeft ? 'md:order-1' : ''}`} />
                    </div>
                  </ScrollReveal>
                );
              })}
            </div>
          </div>



        </div>
      </div>
    </section>
  );
}